'use client';

import React from 'react';
import { Search, Bell } from 'lucide-react';
import CountrySwitcher from './CountrySwitcher';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '@/context/LanguageContext';

interface HeaderProps {
  title: string;
  subtitle?: string;
}

export default function Header({ title, subtitle }: HeaderProps) {
  const { t } = useLanguage();

  return (
    <header
      className="h-16 flex items-center justify-between px-6 bg-surface-card flex-shrink-0 sticky top-0 z-20"
      style={{ borderBottom: '1px solid var(--border)' }}
    >
      <div>
        <h1 className="text-[17px] font-semibold text-text-main leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs text-text-muted mt-0.5">{subtitle}</p>
        )}
      </div>

      <div className="flex items-center gap-3">
        {/* Country Switcher */}
        <CountrySwitcher />

        {/* Language Switcher — 8px gap from CountrySwitcher via gap-3 above */}
        <LanguageSwitcher />

        {/* Search */}
        <div className="relative hidden md:block">
          <Search
            size={14}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted"
          />
          <input
            type="text"
            placeholder={t('header.search')}
            className="bg-surface-light border border-surface-border text-sm rounded-lg pl-8 pr-3 py-1.5 w-64 text-text-main placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent/30 focus:border-accent transition-colors"
          />
        </div>

        {/* Notifications */}
        <button
          className="relative w-8 h-8 flex items-center justify-center rounded-lg hover:bg-surface-light transition-colors"
          aria-label={t('header.notifications')}
        >
          <Bell size={16} className="text-text-muted" />
          <span
            className="absolute top-1 right-1 w-2 h-2 rounded-full"
            style={{ backgroundColor: 'var(--status-red)' }}
          />
        </button>

        {/* Avatar */}
        <div
          className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold text-white flex-shrink-0 cursor-pointer hover:opacity-90 transition-opacity"
          style={{ backgroundColor: 'var(--primary)' }}
          title="George Kwame — Program Manager"
        >
          GK
        </div>
      </div>
    </header>
  );
}